let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gS7xS")).then(() => parcelRequire('i4tNv'));